import compact from "lodash-es/compact";

export const paymentAccountLabel = (account: number, name: string | undefined) => compact([account, name]).join(" - ");
